import { useEffect, useState } from 'react'

import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, AlertProps, Box, Icon } from '@chakra-ui/react'
import { TZDate } from '@date-fns/tz'
import { format } from 'date-fns'

interface RuleScheduleAlertIProps extends AlertProps {
  facilityName: string
  timeZone: string
}

export const RuleScheduleAlert = ({
  facilityName,
  timeZone,
}: RuleScheduleAlertIProps) => {
  if (!facilityName || !timeZone) {
    return null
  }

  const [currentFacilityTime, setCurrentFacilityTime] = useState<string>('')

  const updateCurrentTime = () => {
    // TODO - We should move timezone & date formatting stuff out to own util
    const formattedTime = format(
      new TZDate(new Date(), timeZone),
      // month day, year, hours 1-12:minutes 00-59 AM/PM
      // e.x. June 5, 2025 2:45 PM
      'MMMM d, yyyy h:mm a'
    )
    setCurrentFacilityTime(formattedTime)
  }

  useEffect(() => {
    updateCurrentTime()

    // Kinda hacky, but we'll run this every 5s, and eventually it'll turn over to the "current" minute as time progresses
    const intervalId = setInterval(() => {
      updateCurrentTime()
    }, 5000)

    return () => clearInterval(intervalId)
  }, [timeZone])

  return (
    <Alert
      bg='#DBE9FE'
      borderRadius='10px'
      color='#1D40B0'
      fontSize='13px'
      mb={4}
      status='info'
    >
      <Icon
        as={HiOutlineInformationCircle}
        boxSize='20px'
        color='#1D40B0'
        mr='10px'
      />
      <Box fontWeight={400}>
        <Box as='span'>Selected schedule will be applied in</Box>
        <Box as='span' fontWeight={500}>
          {` ${timeZone} `}
        </Box>
        at {`${facilityName}`}. It is currently
        <Box as='span' fontWeight={500}>
          {' '}
          {`${currentFacilityTime}`}
        </Box>{' '}
        at the selected facility.
      </Box>
    </Alert>
  )
}
